import isAfter from 'date-fns/isAfter';
import isBefore from 'date-fns/isBefore';

export const isDateAfterMin = (date: Date, minDate?: Date): boolean => (minDate ? isAfter(date, minDate) : true);
export const isDateBeforeMax = (date: Date, maxDate?: Date): boolean => (maxDate ? isBefore(date, maxDate) : true);
